import { ComponentType } from 'react';

export function lazyWithRetry<T extends ComponentType<any>>(
  componentImport: any,
  chunkIdentifier: string
): Promise<{ default: T }> {
  const sessionStorageKey = `retry-lazy-refreshed-${chunkIdentifier}`;

  return new Promise((resolve, reject) => {
    const hasRefreshed = JSON.parse(window.sessionStorage.getItem(sessionStorageKey) || 'false');

    componentImport()
      .then((component: any) => {
        window.sessionStorage.setItem(sessionStorageKey, 'false');
        return resolve(component);
      })
      .catch((error: any) => {
        if (!hasRefreshed) {
          window.sessionStorage.setItem(sessionStorageKey, 'true');
          return window.location.reload();
        }

        return reject(error);
      });
  });
}
